import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PharmacyService} from '../../services/pharmacy/pharmacy.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {PharmacyModel} from '../../models/pharmacy/pharmacy.model';
import {Subject, takeUntil} from 'rxjs';
import {iResponse} from '../../models/response/response.model';
import {AddressModel} from '../../models/registration/registration.model';
import {MatInput} from '@angular/material/input';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
    selector: 'app-pharmacy-create',
    imports: [
        ReactiveFormsModule,
        MatInput,
        MatCheckbox
    ],
    templateUrl: './pharmacy-create.component.html',
    styleUrl: './pharmacy-create.component.sass'
})
export class PharmacyCreateComponent implements OnInit, OnDestroy {
    @Output() triggerReloadEmitter: EventEmitter<boolean> = new EventEmitter<boolean>;
    @Output() triggerPharmacyCreate: EventEmitter<boolean> = new EventEmitter<boolean>;
    @Input() pharmacy: PharmacyModel | null = null;
    private destroy$ = new Subject<void>();

    pharmacyForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        phoneNumber: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        isDefault: new FormControl(true, [Validators.required]),
        noSalesTaxes: new FormControl(false),
    });
    pharmacyAddress = new FormGroup({
        city: new FormControl('', [Validators.required]),
        houseNumber: new FormControl('', [Validators.required]),
        street: new FormControl('', [Validators.required]),
        zipCode: new FormControl('', [Validators.required]),
    })

    constructor(
        private pharmacyService: PharmacyService
    ) {
    }

    ngOnInit() {
        if (this.pharmacy) {
            this.pharmacyForm.patchValue(this.pharmacy);
            this.pharmacyAddress.patchValue(this.pharmacy.address);
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    submit() {

        if (this.pharmacyForm.invalid || this.pharmacyAddress.invalid) {
            this.pharmacyForm.markAllAsTouched();
            this.pharmacyAddress.markAllAsTouched();
            return;
        }

        let address: AddressModel = {
            city: this.pharmacyAddress.value!.city!,
            houseNumber: this.pharmacyAddress.value!.houseNumber!,
            street: this.pharmacyAddress.value!.street!,
            zipCode: this.pharmacyAddress.value!.zipCode!,
        }

        let pharmacy: PharmacyModel = {
            address: address,
            email: this.pharmacyForm.value.email!,
            isDefault: true,
            name: this.pharmacyForm.value.name!,
            phoneNumber: this.pharmacyForm.value.phoneNumber!,
            noSalesTaxes: this.pharmacyForm.value.noSalesTaxes!
        }

        if (this.pharmacy) {
            pharmacy.id = this.pharmacy.id;
            this.editPharmacy(pharmacy);
        } else {

            this.createPharmacy(pharmacy);
        }
    }

    cancel(): void {
        this.triggerPharmacyCreate.emit(false);
    }

    private createPharmacy(pharmacy: PharmacyModel): void {
        this.pharmacyService.createPharmacy(pharmacy)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PharmacyModel>) => {
                    this.pharmacyForm.reset();
                    this.pharmacyAddress.reset();
                    this.triggerReloadEmitter.emit();
                    this.triggerPharmacyCreate.emit(false);
                },
                error: (error) => {
                }
            })
    }

    private editPharmacy(pharmacy: PharmacyModel): void {
        this.pharmacyService.updatePharmacy(pharmacy)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PharmacyModel>) => {
                    this.pharmacyForm.reset();
                    this.pharmacyAddress.reset();
                    this.triggerReloadEmitter.emit();
                    this.triggerPharmacyCreate.emit(false);
                },
                error: (error) => {
                }
            })
    }

}
